export default __webpack_public_path__ + "static/media/order_approve.a737c251.svg";